import React from 'react';
import Perpule from "assets/images/perpule.png";
import Cyan from "assets/images/cyan.png";
import Green from "assets/images/green.png";
import Pink from "assets/images/pink.png";
import LightCyan from "assets/images/lightCyan.png";
import LightGreen from "assets/images/lightGreen.png";
import "./index.scss";
import { useThemeContext } from 'theme/ThemeContextProvider';

const Theme = () => {
  const { setMode } = useThemeContext();

  const handleThemeChange = (mode) => {
    setMode(mode);
  };

  return (
    <div className="theme-component-wrapper">
      <div className="themes">
        <img src={Perpule} alt="Perpule" onClick={() => handleThemeChange('light')} />
        <img src={Cyan} alt="Cyan" onClick={() => handleThemeChange('Cyan')} />
        <img src={Green} alt="Green" onClick={() => handleThemeChange('Green')} />
        <img src={Pink} alt="Pink" onClick={() => handleThemeChange('Pink')} />
        <img src={LightCyan} alt="LightCyan" onClick={() => handleThemeChange('LightCyan')} />
        <img src={LightGreen} alt="LightGreen" onClick={() => handleThemeChange('LightGreen')} />
      </div>
    </div>
  );
};

export default Theme;
